export default "__VITE_ASSET__a6c52533__"